/**
 * BIB-02 — cuestionario del bloque/carpeta en la app de farmacia. Las
 * opciones llegan sin la marca de correcta; la corrección es server-side y
 * la nota queda guardada a nombre de la persona activa (C4).
 */
import { page_text } from '../farmaval.js'
import { postTrainingQuizAttempt } from '../clients/farmavel/index.js'

const t = (key) => page_text?.[key] ?? key
const el = (id) => document.getElementById(id)

let current = null // { quiz, staffId, onClose }

export function openQuiz(quiz, staffId, onClose) {
    current = { quiz, staffId, onClose }

    el('formacion_grid').classList.add('hide')
    el('formacion_breadcrumb').classList.add('hide')
    el('formacion_player').classList.add('hide')

    const container = el('formacion_quiz')
    container.classList.remove('hide')
    el('formacion_quiz_title').textContent = quiz.title
    el('formacion_quiz_result').classList.add('hide')
    el('formacion_quiz_result').innerHTML = ''
    el('formacion_quiz_error').classList.add('hide')
    el('formacion_quiz_send').disabled = false
    el('formacion_quiz_send').classList.remove('hide')

    const list = el('formacion_quiz_questions')
    list.innerHTML = ''

    quiz.questions.forEach((question, index) => {
        const wrapper = document.createElement('div')
        wrapper.className = 'formacion_question'

        const text = document.createElement('p')
        text.textContent = `${index + 1}. ${question.text}`
        wrapper.appendChild(text)

        question.options.forEach((option) => {
            const label = document.createElement('label')
            const radio = document.createElement('input')
            radio.type = 'radio'
            radio.name = `q_${question.id}`
            radio.value = String(option.id)
            label.appendChild(radio)
            label.appendChild(document.createTextNode(' ' + option.text))
            wrapper.appendChild(label)
        })

        list.appendChild(wrapper)
    })

    bindOnce()
}

let bound = false
function bindOnce() {
    if (bound) return
    bound = true

    el('formacion_quiz_back').addEventListener('click', (e) => {
        e.preventDefault()
        closeQuiz()
    })

    el('formacion_quiz_send').addEventListener('click', async () => {
        if (!current) return

        const answers = current.quiz.questions.map((question) => {
            const chosen = document.querySelector(`input[name="q_${question.id}"]:checked`)
            return { question_id: question.id, option_id: chosen ? Number(chosen.value) : null }
        })

        if (answers.some((answer) => answer.option_id === null)) {
            el('formacion_quiz_error').classList.remove('hide')
            return
        }

        el('formacion_quiz_error').classList.add('hide')
        el('formacion_quiz_send').disabled = true

        const payload = { answers }
        if (current.staffId !== null) payload.staff_id = current.staffId

        const response = await postTrainingQuizAttempt(current.quiz.id, payload)

        if (!response?.data) {
            el('formacion_quiz_send').disabled = false
            return
        }

        const { score, correct_count, question_count, best_score } = response.data
        const result = el('formacion_quiz_result')
        result.innerHTML = ''

        const line = document.createElement('div')
        line.textContent = `${t('formacion_quiz_result')}: ${score}% (${correct_count}/${question_count})`
        result.appendChild(line)

        const best = document.createElement('div')
        best.textContent = `${t('formacion_quiz_best')}: ${best_score}%`
        result.appendChild(best)

        result.classList.remove('hide')
        el('formacion_quiz_send').classList.add('hide')
    })
}

export function closeQuiz() {
    el('formacion_quiz').classList.add('hide')
    el('formacion_grid').classList.remove('hide')
    el('formacion_breadcrumb').classList.remove('hide')
    const done = current?.onClose
    current = null
    if (done) done()
}
